<template>
  <div class="users container">
    <UserList :users="users" :toggle_user_status="toggle_user_status" />
  </div>
</template>

<script>
import UserList from './UserList'

export default {
  name: 'AdminUsers',
  props: {
    users: {
      type: Array,
      required: true,
    },
    toggle_user_status: {
      type: Function,
      required: true,
    },
  },
  components: {
    UserList,
  },
}
</script>

<style lang="scss" scoped>
.users {
  margin-top: 60px;
}
</style>
